import { useSearchParams } from 'react-router-dom'

import { api } from '../api/client'
import { t } from '../i18n/lingua'
import { InventarioAFogli } from './VInventory'

/**
 * Inventario cloud **tipo RVTools**: istanze, volumi, reti, security group,
 * bilanciatori, basi dati, storage e funzioni, per account o per tutto il
 * cloud del tenant, a video, in Excel o in PDF. Stessa pagina dell'inventario
 * virtuale; i dati da `cloud_map_service.inventario`.
 */
export default function CInventory() {
  const [params] = useSearchParams()
  return (
    <InventarioAFogli
      titolo={t('Inventario cloud')}
      sottotitolo={t('vista completa degli account e delle relative risorse, tra cui istanze, volumi, reti, security group, bilanciatori, database, storage e funzioni, rilevate dai connettori cloud. Consultabile a video o esportabile in Excel e PDF, con un livello di dettaglio analogo a RVTools.')}
      tutto={t('Tutto il cloud')}
      file="censo-cinventory"
      vuotoTitolo={t('Nessuna risorsa cloud')}
      vuotoHint={t('Configura un connettore cloud (AWS, Azure, Google Cloud, Oracle Cloud) e lancia una raccolta.')}
      ambienti={() => api.cinventoryEnvironments()}
      dati={(env) => api.cinventory(env)}
      esportazione={(fmt, env) => api.cinventoryExportPath(fmt, env)}
      iniziale={params.get('account') ?? ''}
    />
  )
}
